import ULDTypeAutocomplete from './ULDTypeAutocomplete'

export default ULDTypeAutocomplete
